<template>
    <Modal @close="onClose">
        <SectionTitle :title="config.PROFILE_DELETE_ADDRESS_TITLE"/>
        <SectionText :text="config.PROFILE_DELETE_ADDRESS_DESCRIPTION"/>
        <section>
            <div v-if="error" class="error">
                {{ error.message }}
            </div>
            <SectionActions>
                <Button flat :style="configStyles.primary.text" @click="onClose">
                    {{ config.PROFILE_DELETE_ADDRESS_CANCEL }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" :disabled="loading" @click="onSubmit">
                    <Spinner v-if="loading" :color="config.COLOR_PRIMARY" class="spinner"/>
                    <span v-else>{{ config.PROFILE_DELETE_ADDRESS_CONFIRM }}</span>
                </Button>
            </SectionActions>
        </section>
    </Modal>
</template>
<script>
import { TrackingConsumer, SolutionConsumer, UserConsumer } from '../../mixins';
import {
    SectionTitle, SectionActions, SectionText,
} from './index';
import { Spinner } from '../lib';

export default {
    name: 'ModalAddressDelete',
    components: {
        Spinner,
        SectionTitle,
        SectionActions,
        SectionText,
    },
    mixins: [TrackingConsumer, SolutionConsumer, UserConsumer],
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },
    data () {
        return {
            loading: false,
            error: null,
        };
    },
    methods: {
        onClose () {
            this.$emit('close');
        },
        async onSubmit () {
            this.loading = true;
            this.error = null;

            try {
                await this.deleteAddress(this.address.id);
                await this.updateUser();
                this.onClose();
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
section {
  .spinner {
    width: 20px;
    height: 20px;
  }

  .spinner + span {
      margin-right: 20px;
  }

  .error {
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;
    color: red;
  }
}

</style>
